// extracted by mini-css-extract-plugin
module.exports = {"appContainer":"styles_appContainer__2912g"};